export { default } from './title-block';
